import { render, staticRenderFns } from "./UtilWarningOffline.vue?vue&type=template&id=72fad7db&scoped=true"
import script from "./UtilWarningOffline.vue?vue&type=script&lang=js"
export * from "./UtilWarningOffline.vue?vue&type=script&lang=js"
import style0 from "./UtilWarningOffline.vue?vue&type=style&index=0&id=72fad7db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fad7db",
  null
  
)

export default component.exports